import React from 'react';
import { LockIcon, UnlockIcon } from 'lucide-react';
import { manifesto } from '../data/profile';
export function Manifesto() {
  return <section id="manifiesto" aria-labelledby="manifiesto-titulo" className="border-b border-hairline bg-panel py-24 lg:py-32" data-id="element-121" data-mp="xpsbc7ix0y6a">
      <div className="mx-auto max-w-6xl px-6" data-id="element-122" data-mp="16i3r8zgel380">
        <div className="grid gap-14 lg:grid-cols-[minmax(0,340px)_minmax(0,1fr)]" data-id="element-123" data-mp="16j5ctxv1p83z">
          <div data-id="element-124" data-mp="itsy6igy87ua">
            <p className="font-mono text-xs text-magenta" data-id="element-125" data-mp="itb4ntlo87q2">02 — Manifiesto</p>
            <h2 className="mt-3 font-mono text-3xl font-bold tracking-tight text-ink-hi" data-id="element-126" data-mp="esr7iq13l43x">
              Por qué está todo abierto
            </h2>
            <div className="mt-6 space-y-4 font-mono text-[13px]" data-id="element-127" data-mp="souohhmynfyg">
              <div className="flex items-center gap-3 text-ink-mid" data-id="element-128" data-mp="nqje95sr73fp">
                <LockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-129" data-mp="245ktwyjk83r0" />
                <span data-id="element-130" data-mp="1z7jcsj5p2ei6">antes — todo guardado</span>
              </div>
              <div className="ml-2 h-6 w-px bg-hairline" aria-hidden="true" data-id="element-131" data-mp="1z9dnl4n94q8j" />
              <div className="flex items-center gap-3 text-teal" data-id="element-132" data-mp="atum7ksenas6">
                <UnlockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-133" data-mp="fso3loatblxm" />
                <span data-id="element-134" data-mp="kstmaez3ty3k">junio 2026 — todo público</span>
              </div>
            </div>
          </div>

          <div data-id="element-135" data-mp="prddatsk202s">
            <p className="max-w-2xl leading-relaxed text-ink-mid" data-id="element-136" data-mp="prwu276gyif8">{manifesto.before}</p>

            <blockquote id="manifiesto-titulo" className="my-10 border-l-2 border-magenta pl-6 font-mono text-2xl font-medium leading-snug tracking-tight text-ink-hi sm:text-3xl" data-id="element-137" data-mp="3o9skru3alp1k">
              {manifesto.turn}
            </blockquote>

            <p className="max-w-2xl leading-relaxed text-ink-mid" data-id="element-138" data-mp="6ssnd52eh0qq">{manifesto.after}</p>
          </div>
        </div>
      </div>
    </section>;
}